import { Box, styled } from '@mui/material';

const StyledLargeSessionCardContent = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex'
}));

export default StyledLargeSessionCardContent;
